import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { ArticleGetDetail, ResourceGetDetail } from '../../api/orgService';
import useApi from '../../api/useApi';
import { toast } from 'react-toastify';
import FilePreviewer from '../sections/FilePreviewer';
import SkeletonCard from '../sections/SkeletonCard';
// import FilePreviewer from '../../sections/FilePreviewer';

function ResourcePublicRead() {
  const location = useLocation()
  const [publishedData,setPublushedData] = useState({})
  const [editState,setEditState] = useState(false)
  const { request: getAllArticle, data:articleData, error:articleError,isLoading} = useApi(ResourceGetDetail);

  useEffect(()=>{
    if(location?.state){
      getAllArticle(location?.state?.resourceID)
    }else if(location?.state === null){
      console.log(location?.pathname.split("/"))
      if(location?.pathname?.includes("/resource/detail/")){
      getAllArticle(location?.pathname.split("/")[3])
    }
    }
  },[location])

  useEffect(()=>{
    if (articleData?.status===200) {
      setPublushedData(articleData?.data);
    }
  },[articleData])

  useEffect(()=>{
      if(articleError){
          toast.error(`${JSON.stringify(articleError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[articleError])

  // console.log(publishedData)
  if(isLoading){
    return <SkeletonCard/>
  }

  return (
    <div>
        {/* <ArticlePage articleData={publishedData} isArticleAdminRead={true}/> */}
        <FilePreviewer fileUrl={publishedData?.file_path} fileName={`${publishedData?.file_path?.split("/").pop()}`} />
    </div>
  )
}

export default ResourcePublicRead